import { bl_aat_engagement_fye_employee_link_RowClass, bl_aat_engagement_fye_hdr_RowClass, bl_fi_entity_hdr_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class EngagementFYEEmployeeLinkCustomContainerModel extends BaseContainerModel {
    bl_aat_engagement_fye_employee_link: bl_aat_engagement_fye_employee_link_RowClass = new bl_aat_engagement_fye_employee_link_RowClass();
    bl_aat_engagement_fye_hdr: bl_aat_engagement_fye_hdr_RowClass = new bl_aat_engagement_fye_hdr_RowClass();
    bl_fi_mst_entity_hdr: bl_fi_entity_hdr_RowClass = new bl_fi_entity_hdr_RowClass();
}
